import { render } from "./AiAuths.vue?vue&type=template&id=abbc0c7c&scoped=true"
import script from "./AiAuths.vue?vue&type=script&lang=js"
export * from "./AiAuths.vue?vue&type=script&lang=js"

import "./AiAuths.vue?vue&type=style&index=0&id=abbc0c7c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abbc0c7c"]])

export default __exports__